import PermissionRoute from '@Src/_basic/helpers/PermissionRoute';
import { RouteConfig } from '@Src/app/BasicRouter';
import React, { memo } from 'react';
import RemainingKPIScreen from './screens/RemainingKPIScreen';

const routesConfig: RouteConfig[] = [
  {
    path: '/',
    element: <RemainingKPIScreen />,
  },
];

const RemainingKPIRouter = () => PermissionRoute(routesConfig);

export default memo(RemainingKPIRouter);
